import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { useAuth, login } from "../../auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import {
  faAngleLeft,
  faUnlockAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  FormCheck,
  Container,
  InputGroup,
  Modal,
  Image,
} from "@themesberg/react-bootstrap";

import SigninLogo from "../../assets/img/signin_logo_new.png";
import ServiceBlow2 from "../../assets/img/PATINEX_serviceblow2_eng.jpg";
import ServiceBlow3 from "../../assets/img/PATINEX_serviceblow3_eng.png";
import ServiceImg2 from "../../assets/img/PATINEX_serviceImg2_eng.jpg";

import MainLogo from "../../assets/img/RUBI_main_logo_x.png";
import MainLogo2 from "../../assets/img/web_rubi_icon.png";
import GuideImg from "../../assets/img/RUBI_User Guide.jpg";
import GuideImg_RU from "../../assets/img/RUBI_User Guide_rus.png";

import { Routes } from "../../routes";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
  standardFontDataUrl: 'standard_fonts/',
};

export default () => {
  const [input, setInput] = useState({ id: "", password: "" });
  const [msg, setMsg] = useState("");
  const { id, password } = input;

  const [file, setFile] = useState("../../assets/img/comapyContent2_220528.pdf");
  const [numPages, setNumPages] = useState(null);

  function onFileChange(event) {
    setFile(event.target.files[0]);
  }

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }


  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
        <Form>
          <Row>
            <Col lg={2} className="p-0">
              <Image src={MainLogo2} draggable="false" width='75%' height='75%' />
            </Col>
            <Col lg={2} className="p-0 offset-md-4">
              <Button type="button" className="w-75" href={Routes.Signin.path}>
                <FormattedMessage id="login" />
              </Button>
            </Col>
            <Col lg={2} className="p-0">
              <Button type="button" className="w-75" href={Routes.Signup.path}>
                <FormattedMessage id="signup" />
              </Button>
            </Col>
          </Row>
        </Form>
          <Row className="justify-content-center form-bg-image">
            <Image src={GuideImg_RU} draggable="false" width='75%' height='75%' />
            <Image src={GuideImg} draggable="false" width='75%' height='75%' />
          </Row>
        </Container>
      </section>
    </main>
  );
};
